function customSelectInit() {
    $('select').each(function () {
        if (!$(this).hasClass('js-phone-code')) {
            transformSelectToCustomSelect(this);
        }
    });
}

function transformSelectToCustomSelect(select) {

    const originalSelect = $(select);
    const customSelect = $('<div class="custom-select"></div>');
    const selectText = $('<div class="select-text"></div>');
    selectText.text(originalSelect.find('option:selected').text());
    customSelect.append(selectText);

    if (originalSelect.prop('disabled') === true) {
        customSelect.addClass('disabled')
    }

    const selectOptions = $('<div class="select-options"></div>');
    originalSelect.find('option').each(function () {
        const option = $('<div class="select-option"></div>');
        option.text($(this).text());
        option.attr('data-value', $(this).val());

        // Nastavení třídy is-selected, pokud je tato možnost vybrána
        if ($(this).is(':selected')) {
            option.addClass('is-selected');
        }

        selectOptions.append(option);
    });

    customSelect.append(selectOptions);
    originalSelect.before(customSelect);
    originalSelect.hide();

    if (customSelect.hasClass('disabled')) {return}

    customSelect.on('click', function () {
        $('.custom-select').not(this).removeClass('is-open');
        customSelect.toggleClass('is-open');
    });

    selectOptions.on('click', '.select-option', function () {
        const value = $(this).attr('data-value');
        const text = $(this).text();

        // Odebrání třídy is-selected ze všech možností a nastavení nové
        selectOptions.find('.select-option').removeClass('is-selected');
        $(this).addClass('is-selected');

        selectText.text(text);
        originalSelect.val(value);
        originalSelect.trigger('change');
    });

    originalSelect.on('change', function () {
        selectText.text(originalSelect.find('option:selected').text());

        // Synchronizace třídy is-selected při změně na originálním selectu
        const selectedValue = originalSelect.val();
        selectOptions.find('.select-option').each(function () {
            if ($(this).attr('data-value') === selectedValue) {
                $(this).addClass('is-selected');
            } else {
                $(this).removeClass('is-selected');
            }
        });
    });

    $(document).on('click', function (e) {
        // Pokud kliknutí nebylo na custom select nebo jeho potomky
        if (!$(e.target).closest('.custom-select').length) {
            $('.custom-select').removeClass('is-open');
        }
    });

}

